import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const HomeSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2362 1.93369C11.5249 1.67013 11.9017 1.52399 12.2926 1.52399C12.6835 1.52399 13.0603 1.67014 13.3489 1.9337L13.3503 1.93496L21.6816 9.50601L21.6923 9.51589C21.8471 9.66219 21.9711 9.83798 22.057 10.0329C22.143 10.228 22.189 10.4383 22.1925 10.6514L22.1926 10.6637V20.2987C22.1926 20.7142 22.0275 21.1127 21.7337 21.4065C21.4399 21.7003 21.0414 21.8654 20.6259 21.8654H15.6259C15.2104 21.8654 14.8119 21.7003 14.5181 21.4065C14.2243 21.1127 14.0592 20.7142 14.0592 20.2987V15.2987C14.0592 15.2435 14.0145 15.1987 13.9592 15.1987H10.6259C10.5707 15.1987 10.5259 15.2435 10.5259 15.2987V20.2987C10.5259 20.7142 10.3609 21.1127 10.067 21.4065C9.77324 21.7003 9.37475 21.8654 8.95924 21.8654H3.95924C3.54374 21.8654 3.14525 21.7003 2.85144 21.4065C2.55764 21.1127 2.39258 20.7142 2.39258 20.2987V10.6633L2.39268 10.651C2.39618 10.438 2.44224 10.2279 2.52815 10.0329C2.61411 9.83785 2.73824 9.66194 2.89323 9.51557L2.90426 9.50536L11.2351 1.93473L11.2362 1.93369ZM12.36 3.01677C12.3218 2.98195 12.2634 2.98195 12.2252 3.01676L12.2231 3.01863L3.89954 10.582L3.89277 10.5895C3.88349 10.5999 3.87589 10.6116 3.87028 10.6244C3.86443 10.6376 3.86047 10.6517 3.85924 10.6661V20.2987C3.85924 20.3539 3.90402 20.3987 3.95924 20.3987H8.95924C9.01447 20.3987 9.05924 20.3539 9.05924 20.2987V15.2987C9.05924 14.8832 9.2243 14.4847 9.51811 14.1909C9.81192 13.8971 10.2104 13.7321 10.6259 13.7321H13.9592C14.3747 13.7321 14.7732 13.8971 15.067 14.1909C15.3609 14.4847 15.5259 14.8832 15.5259 15.2987V20.2987C15.5259 20.3539 15.5707 20.3987 15.6259 20.3987H20.6259C20.6811 20.3987 20.7259 20.3539 20.7259 20.2987L20.7263 10.6746L20.7255 10.6661C20.7243 10.6517 20.7207 10.6376 20.7149 10.6244L12.2252 3.01676L20.6928 10.5892L12.3619 3.01852L12.36 3.01677Z"
        fill={color}
      />
    </svg>
  );
};

export { HomeSvg };
